import styles from "./Button.module.css"

export default function Button({handleClick, children}){
    return (
        <button className={styles.button} onClick={handleClick}>{children}</button>
    )
}